<template>
  <div id="topRight" class="content-box-item">
    <div class="top-left">
      <div class="top-left-top">
        <el-image :src="require('@/assets/icons/icon-9.png')" fit="fit"/>
        <span class="top-left-txt">数据统计</span>
      </div>
      <div class="top-left-bottom">
          <div class="bottom-left">
            <div class="data-item">
              <div class="data-item-left">
                <span class="text-0" style="background: linear-gradient(120.93deg, #f49b0b 3.98%, #f7b954 100%)"></span>
              </div>

              <div class="data-item-right">
                <span class="text-1">邀约成功</span>
                <span class="text-2">{{cdata.tagClientCount}} 人</span>
              </div>
            </div>
            <div class="data-item">
              <div class="data-item-left">
                <span class="text-0" style="background: linear-gradient(120.93deg, #1a77bf 3.98%, #5eb0f0 100%);"></span>
              </div>
              <div class="data-item-right">
                <span class="text-1">意向客户</span>
                <span class="text-2">{{cdata.tagClientOKCount}} 人</span>
              </div>
            </div>
            <div class="data-item">
              <div class="data-item-left">
                <span class="text-0" style="background: linear-gradient(120.93deg, #917afc 3.98%, #c4b9fd 100%)"></span>
              </div>
              <div class="data-item-right">
                <span class="text-1">失败客户</span>
                <span class="text-2">{{cdata.tagClientGiveUpCount}} 人</span>
              </div>
            </div>
          </div>
      </div>
      <div class="bottom-right">
        <TypePie :clue="cdata"  class="type_pie" style="width: 115%;height: 115%;"/>
      </div>
    </div>
    <div class="top-right">
      <TypeLine2  :clue="cdata" class="type_line"  style="width: 100%;"/>
    </div>
  </div>
</template>

<script>
  import TypeLine2 from '@/components/echart/TypeLine2';
  import TypePie from '@/components/echart/TypePie'
export default {
  data() {
    return {
      lineData: {
        dayCategory: [],
        dayLineData: [],
      },
    }
  },
  //
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  components: {
    TypeLine2,
    TypePie,
  },
  watch: {
    cdata: {
      handler (newData) {

      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
#topRight {
  width: calc(100% - 20px);
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  .top-left{
    width: 52%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    position: relative;

  }
  .top-left-top{
    width: 86%;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    margin-top: 5px;
  }
  .top-left-txt{
    font-size: 20px;
    line-height: 60px;
    text-align: center;
    margin-left: 20px;
    color: #000000;
  }
  .top-right{
    width: 48%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .top-left-bottom{
    width: 100%;
    height: calc(100% - 65px);;
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: start;

  }
  .bottom-left{
    width: 45%;
    height: auto;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: end;
    justify-content: start;
  }
  .data-item{
    width: 85%;
    height: 56px;
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: start;
  }
  .data-item-left{
    width: 20px;
    height: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .data-item-right{
    width: auto;
    height: 100%;
    display: flex;
    margin-left: 10px;
    flex-direction: column;
    align-items: start;
    justify-content: start;
  }
  .text-0{
    width: 20px;
    height: 18px;
    border-radius: 4px;
  }
  .text-1{
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    color: #6e8096;
  }
  .text-2{
    font-size: 18px;
    line-height: 28px;
    text-align: left;
    color: #000000;
  }
  .bottom-right{
    position: absolute;
    top: 15px;
    left: 100px;
    bottom: 0;
    right: 0;
  }
  .type_pie{
    height: 100%;
  }
  .type_line{
    margin-top: -30px;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/data/top/topRight.vue